import gsap from 'gsap'

const init = (el) => {
  const params = {
    autoAlpha: 0,
    y: 30,
  }

  return gsap.set(el, Object.assign({}, params))
}

const anim = (el, extraParams) => {
  const params = {
    autoAlpha: 1,
    y: 0,
    clearProps: 'transform',
    ease: 'expo.out',
    duration: 0.8,
    clearProps: 'all',
  }
  return gsap.to(el, Object.assign({}, params, extraParams))
}

export {
  init,
  anim
}
